import { styled } from "@material-ui/core";

export const OrganisationDetailsContainer = styled("div")({
  flexDirection: "column",
  display: "flex",
  height: "100%",
});

export const OrganisationDetailsItem = styled("div")({
  flexGrow: 1,
  display: "flex",
  alignItems: "center",
});



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/OrganisationDetails/OrganisationDetails.styles.js